import { createSelector } from 'reselect';

const selectCCAvenues = (state: any) => state.ccAvenues;

export const selectCCAvenuesCurrentItem = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.current);

export const selectCCAvenuesListItems = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.list);

export const selectCCAvenuesItemById = (itemId: any) =>
    createSelector(selectCCAvenuesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCCAvenuesQueryItems = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.query);

export const selectCCAvenuesCreatedItem = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.create);

export const selectCCAvenuesUpdatedItem = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.update);

export const selectCCAvenuesReadItem = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.read);

export const selectCCAvenuesDeletedItem = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.delete);

export const selectCCAvenuesSearchedItems = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.search);

export const selectCCAvenuesItemsCount = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.count);

export const selectCCAvenuesItemsFilter = createSelector([selectCCAvenues], (ccAvenues) => ccAvenues.filter);